export default __webpack_public_path__ + "b0212a0fe5b0aea4daba6bda45de5402.svg";